import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
  topBar: {
    position: "sticky",
    top: "0",
    left: "0",
    zIndex: "10",
    display: "flex",
    alignItems: "center",
    minHeight: "4rem",
    width: "100%",
    backgroundColor: "#45969B",
    "& img": {
      position: "relative",
      height: "3rem",
      marginLeft: "1rem",
    },
    "& h1": {
      color: "#fff",
      fontSize: "1.5rem",
      fontWeight: "500",
      padding: "1rem",
    },
  },
  wrapper: {
    display: 'flex',
    width: "100%",
    minHeight: "calc(100vh - 17rem)",
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  waveTop: {
    width: "100%",
    "& > img": {
      display: "block",
      objectFit: "fill",
      width: "100%",
      height: "6rem",
    },
  },
  waveBottom: {
    width: "100%",
    "& > img": {
      display: "block",
      width: "100%",
      height: "6rem",
      marginBottom: "3rem"
    },
  },
})